"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.DefaultMap = void 0;
class DefaultMap extends Map {
    constructor(_defaultFunc, initKVPs) {
        super(initKVPs);
        this._defaultFunc = _defaultFunc;
    }
    get(k) {
        let v = super.get(k);
        if (v === undefined) {
            v = this._defaultFunc(k);
            this.set(k, v);
        }
        return v;
    }
    update(k, f) {
        const v = f(this.get(k));
        this.set(k, v);
        return v;
    }
}
exports.DefaultMap = DefaultMap;
//# sourceMappingURL=default-map.js.map